import React from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select, colors } from '@material-ui/core';
import { Component } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { setError } from '../../redux/actions/MessageAction';
import { adminPanelBaseStyles } from '../../theme/style';
import { Loading } from '../common';
import Alerts from '../common/Alerts';

class ClinicUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        username: '',
        status: 1,
        email: '',
        password: '1SRTsrt4243gDPT!!@@#$@$@#$%#@TSAR234',
        role: 1,
      },
      statusOpen: false,
      isLoading: false,
    };
  }
  componentDidMount() {}
  onChange = ({ name, value }) => {
    let newUser = { ...this.state.user, [name]: value };
    this.setState({ user: newUser });
    this.props.setError('');
  };

  validateEmail(email) {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  }

  checkValidity = () => {
    const { email, last_name, first_name, username } = this.state.user;
    if (first_name === '' || last_name === '' || email === '' || username === '') {
      throw new Error('fields cannot be empty ');
    }
    if (first_name.match(/\d/)) throw new Error('first name cannot contain numbres ');
    if (last_name.match(/\d/)) throw new Error('last name cannot contain numbres ');
    if (!this.validateEmail(email)) throw new Error('email must be valid email');

    return true;
  };

  onClick = async () => {
    if (this.state.isLoading) return;
    try {
      this.checkValidity();

      this.setState({ isLoading: true });
      console.log('validity successfully ');

      await this.props.handleClick(this.props.clinicId?.toString(), this.state.user, this.props.closeModal);
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 2000);
    } catch (error) {
      console.log('checkValidity error: ');
      console.log(error.message);
      this.props.setError(error.message);
      this.setState({ isLoading: false });
    }
  };

  handleStatusClose = () => {
    this.setState({ statusOpen: false });
  };

  handleStatusOpen = () => {
    this.setState({ statusOpen: true });
  };

  render() {
    // / cehck that and put in thet other modal of the paitent
    console.log('rendering');
    console.log(this.state);
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.props.showModal}
        style={{
          content: { ...styles.centerModal },
        }}
        // onAfterOpen={afterOpenModal}
        onRequestClose={() => this.props.closeModal()}
        // style={customStyles}
        contentLabel="Diagnosis Modal"
      >
        <div style={styles.container}>
          <AiOutlineCloseCircle style={styles.closeButton} onClick={() => this.props.closeModal()} />
          <div style={styles.title}>{this.props.title}</div>
          <div style={styles.insideContainer}>
            <dl>
              <dt>first name</dt>
              <dd>
                <input name="first_name" value={this.state.first_name} onChange={(e) => this.onChange(e.target)} />
              </dd>

              <dt>last name</dt>
              <dd>
                <input name="last_name" value={this.state.last_name} onChange={(e) => this.onChange(e.target)} />
              </dd>
              <dt>username</dt>
              <dd>
                <input name="username" value={this.state.username} onChange={(e) => this.onChange(e.target)} />
              </dd>
              <dt>email</dt>
              <dd>
                <input name="email" value={this.state.email} onChange={(e) => this.onChange(e.target)} />
              </dd>
            </dl>

            <FormControl style={adminPanelBaseStyles.select}>
              <InputLabel>Role Status</InputLabel>
              <Select
                open={this.state.statusOpen}
                onClose={this.handleStatusClose}
                onOpen={this.handleStatusOpen}
                value={this.state.user.role}
                onChange={(e) => this.onChange({ name: 'role', value: e.target.value })}
                inputProps={{ name: 'user Status' }}
              >
                <FormHelperText>
                  <em>Role</em>
                </FormHelperText>
                <MenuItem value={1}>User</MenuItem>
                <MenuItem value={0}>Administrator</MenuItem>
              </Select>
            </FormControl>

            <div onClick={this.onClick} style={!this.state.isLoading ? styles.button : styles.buttonDisabled}>
              {this.props.title}
            </div>
          </div>
          <Alerts />
          {this.state.isLoading && <Loading style={{ paddingTop: 2 }} />}
        </div>
      </Modal>
    );
  }
}

const styles = {
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  buttonClose: {
    position: 'absolute',
    top: 1,
    right: 1,
  },

  button: {
    backgroundColor: '#4CAF50',
    cursor: 'pointer',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonDisabled: {
    backgroundColor: '#9f9f9f',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  error: {
    color: 'red',
  },

  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
};
const mapStateToProps = (state, ownProps) => {
  return {
    error: state.message.error,
  };
};

const mapDispatchToProps = {
  // setError,

  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClinicUserModal);
